module.exports = __webpack_public_path__ + "static/case-study-2-85a7f578f773feedc671f1c53f970bf0.png";